import { Badge } from '@fluentui/react-components'

type LozengeColor = 'brand' | 'danger' | 'important' | 'informative' | 'severe' | 'subtle' | 'success' | 'warning'

/**
 * Jira-lozenge-style status badge (bold, uppercase, colored outline) — the shared visual for any
 * short status/tag text in this app (sidebar ingestion method, Licenses page person status, ...),
 * so they all read as the same kind of thing.
 */
export default function Lozenge({
  color,
  size = 'small',
  style,
  children,
}: {
  color: LozengeColor
  size?: 'extra-small' | 'small' | 'medium'
  /** Overrides the semantic `color`'s text/border — for cases like External, where the closest
   * built-in semantic color (`informative`) renders the same blue as `brand` in this theme and
   * needs an explicit, visually distinct token instead. */
  style?: React.CSSProperties
  children: React.ReactNode
}) {
  return (
    <Badge
      appearance="outline"
      color={color}
      shape="rounded"
      size={size}
      style={{ fontWeight: 700, letterSpacing: '0.3px', textTransform: 'uppercase', whiteSpace: 'nowrap', ...style }}
    >
      {children}
    </Badge>
  )
}
